import { z } from 'zod';

export const MaskFormSchema = z.object({
  updatedAt: z.string().optional(),
  maskUrl: z.union([z.string().min(1, 'Mask is required'), z.instanceof(File)]),
  name: z
    .string()
    .min(3, 'Mask name must be at least 3 characters long')
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'Only letters and numbers are allowed',
    })
    .max(100, 'Mask name cannot exceed 100 characters'),
});

export type MaskFormValues = z.infer<typeof MaskFormSchema>;
